/* global $ openPath */

function headBlock(message) {
	if ($(window).data("blockUI.isBlocked") != 1)
	{
		$.blockUI({ message: message,
			fadeIn: 0,
			baseZ: 100000,
			css: {border: 'none', 
				padding: '15px', 
				backgroundColor: '#000', 
				'-webkit-border-radius': '10px', 
				'-moz-border-radius': '10px',
				'border-radius': '10px',
				opacity: .5, 
				'font-weight': 'bold',
				'font-size': '13px',
				color: '#fff'
			}
		});
	}
}

function navBlock(path, method) {

	if (!path) {
		path = window.openPath[window.openPath.length - 1];
	}
	else if (path.indexOf("/")) {
		path = path.split("/").pop();
	}
	if (!method) {
		method = 'GET';
	}
	else {
		method = method.toUpperCase();
	}

	const message = loadingMessages[path];
	if (typeof message === 'object') {
		message[method] && headBlock(message[method]);
	}
	else if (typeof message === "string") {
		headBlock(message);
	}
}

const loadingMessages = {
	'account-overview': 'Building overview. Please wait...',
	'client-dashboard': 'Building dashboard. Please wait...',
	'client-chart-builder': 'Preparing chart builder. Please wait...',
	'client-regression-analysis': {'POST': 'Preparing report. Please wait...'},
	'client-summary': 'Preparing summaries. Please wait...',
	'maintain-campaign': {'POST': 'Loading campaign. Please wait...'},
	'create-campaign': {'POST': 'Loading. Please wait...'},
	'manage-alarms': 'Preparing Alarm Editor. Please wait...',
	'manage-audits': 'Preparing Audits. Please wait...',
	'manage-user-groups': 'Preparing editor. Please wait...',
	'manage-invoices': 'Preparing Invoice Editor. Please wait...',
	'manage-labels': 'Preparing Label Editor. Please wait...',
	'manage-orders': 'Preparing Order Editor. Please wait...',
	'manage-organisations': 'Preparing Account Editor. Please wait...',
	'manage-pricing': 'Preparing Pricing. Please wait...',
	'manage-roles': 'Preparing Role Editor. Please wait...',
	'manage-users': 'Preparing User Editor. Please wait...',
	'plan-tv-campaign': 'Loading. Please wait...',
	'plan-tv-campaign?page=router': 'Loading. Please wait...',
	'plan-tv-campaign-management?page=edit': 'Loading. Please wait...',
	'plan-tv-campaign-management': 'Preparing Plan Management. Please wait...',
	'tv-reports': 'Loading Reports. Please wait...',
	'tv-summary': 'Loading Summaries. Please wait...',
	'tv-overview': 'Building overview. Please wait...',
	'tv-campaign': 'Building dashboard. Please wait...',
	'tv-chart-builder': 'Preparing Chart Builder. Please wait...',
	'tv-period-analysis': 'Preparing report. Please wait...',
	'tv-comparison-analysis': {'POST': 'Preparing report. Please wait...'},
	'tv-attributed-target-analysis': {'POST': 'Preparing report. Please wait...'},
	'tv-schedule-view': 'Preparing report. Please wait...',
	'tv-slot-analysis': {'POST': 'Preparing report. Please wait...'},
	'tv-channel-analysis': {'POST': 'Preparing report. Please wait...'},
	'tv-programme-analysis': {'POST': 'Preparing report. Please wait...'},
	'tv-saleshouse-analysis': {'POST': 'Preparing report. Please wait...'},
	'tv-creative-analysis': {'POST': 'Preparing report. Please wait...'},
	'tv-correlation-comparison-analysis': {'POST': 'Preparing report. Please wait...'},
	'tv-correlation-matrix-analysis': {'POST': 'Preparing report. Please wait...'},
	'tv-correlated-target-analysis': {'POST': 'Preparing report. Please wait...'},
	'tv-statistical-analysis': {'POST': 'Preparing report. Please wait...'},
	'tv-coverage-analysis': {'POST': 'Preparing report. Please wait...'},
	'tv-matrix-analysis': {'POST': 'Preparing report. Please wait...'},
	'tv-optimisation': {'POST': 'Preparing report. Please wait...'},
	'tv-response-analysis': {'POST': 'Preparing report. Please wait...'},
	'tv-response-baseline-analysis': {'POST': 'Preparing report. Please wait...'},
	'tv-response-channel-analysis': {'POST': 'Preparing report. Please wait...'},
	'tv-geo': 'Preparing map. Please wait...',
	'spot-sync': 'Preparing Spot Sync Editor. Please wait...',
	'system-administration': 'Preparing System Administration. Please wait...',
	'view-tv-fusion-chart-builder': {'POST': 'Preparing Chart. Please wait...'},
	'view-client-fusion-chart-builder': 'Preparing Chart. Please wait...',
	'press-campaign':'Building dashboard. Please wait...',
	'press-chart-builder': 'Preparing Chart Builder. Please wait...',
	'press-summary': 'Building summary. Please wait...',
	'press-launchpad': 'Loading. Please wait...',
	'press-comparison-analysis': {'POST': 'Loading. Please wait...'},
	'press-matrix-analysis': {'POST': 'Preparing report. Please wait...'},
	'press-correlation-comparison-analysis': {'POST': 'Preparing report. Please wait...'},
	'press-correlation-matrix-analysis': {'POST': 'Preparing report. Please wait...'},	
	'press-coverage-analysis': {'POST': 'Preparing report. Please wait...'},
	'press-creative-analysis': {'POST': 'Preparing report. Please wait...'},
	'press-insertion-analysis': {'POST': 'Preparing report. Please wait...'},
	'press-geo': 'Preparing map. Please wait...',
	'press-period-analysis': 'Preparing report. Please wait...',
	'press-publication-analysis': {'POST': 'Preparing report. Please wait...'},
	'press-regression-analysis': {'POST': 'Preparing report. Please wait...'},
	'research-reports': 'Loading Reports. Please wait...',
	'research-audience-conversion-rate-analysis': {'POST': 'Preparing report. Please wait...'},
	'research-audience-analysis': {'POST': 'Preparing report. Please wait...'},
	'research-brand-analysis': {'POST': 'Preparing report. Please wait...'},
	'research-agency-analysis': {'POST': 'Preparing data. Please wait...'},
	'research-share-of-voice': {'POST': 'Preparing report. Please wait...'},
	'research-share-of-voice?action=usage': 'Preparing report. Please wait...',
	'manage-audiences': 'Loading audiences. Please wait...',
};

$(document).on("submit", function(e) {
	navBlock(e.target.getAttribute("action"), e.target.method);
});

$(document).on("click", "a", function(e) {
	if(
		!e.currentTarget.href ||
		e.button == 1 || e.ctrlKey || e.metaKey // prevent blocking opening new tab
	) { return; }
	navBlock(e.currentTarget.href);
});
